var modules_8bb178ca = {"container":"_1gagwpv","iconWrapper":"_1cjv6au","icon":"_1x4oec4","bounceIn":"_1yyh8ci","bounce-in":"_vrucvn","bounceOut":"_7omimz","bounce-out":"_5fmges"};
import "../../../assets/DFNqteSr.css";

export { modules_8bb178ca as default };
//# sourceMappingURL=ThemeSwitcher.module.less.js.map
